/**
 * Application entry point.
 * Initializes Web Components, router, and global state.
 */

// Import styles (Vite will bundle these)
import './styles/tailwind.css';

// Import UI primitives (E00b)
import './components/ui';

// Import app shell components (E00c)
import './components/app';

// Import page components (E00d)
import './components/pages';

// Import MSAL auth service for initialization
import { initializeMsal, handleRedirectCallback } from './services/msal-auth.service';
import { authActions, authState } from './state/auth.state';
import { getReturnUrl, clearReturnUrl, navigate, isAuthCallbackPath } from './router';
import { getDefaultPostAuthPath } from './auth-navigation';

// Initialize the application when DOM is ready
async function init(): Promise<void> {
  try {
    const onAuthCallbackRoute = isAuthCallbackPath();

    // Initialize MSAL
    await initializeMsal();

    // Handle redirect callback from MSAL (if returning from login)
    const authResult = await handleRedirectCallback();

    if (authResult) {
      console.log('User authenticated via redirect');
    }

    // Restore auth state from MSAL cache
    await authActions.restoreAuthState();

    // Post-auth redirect: check for stored return URL
    const returnUrl = getReturnUrl();
    if (returnUrl && authState.get().isAuthenticated) {
      clearReturnUrl();
      navigate(returnUrl, { replace: true });
      return;
    }

    if (window.location.pathname === '/login' && authState.get().isAuthenticated) {
      navigate(getDefaultPostAuthPath(), { replace: true });
      return;
    }

    if (onAuthCallbackRoute) {
      navigate(
        authState.get().isAuthenticated ? getDefaultPostAuthPath() : '/login',
        { replace: true }
      );
    }

    console.log('Venom Dog Sports app initialized');
  } catch (error) {
    if (isAuthCallbackPath()) {
      navigate('/login', { replace: true });
    }

    console.error('Failed to initialize app:', error);
  }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

